import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class IdentityProviderGuard implements CanActivate {
  constructor(private router: Router) {}

  public canActivate(): boolean {
    const params = new URLSearchParams(window.location.search);
    if (params.get('code')) {
      const state = params.get('state');
      const queryParams: { [k: string]: string } = {};
      if (state) {
        queryParams['state'] = state;
      }
      this.router.navigate(
        [`login-identity-provider/${params.get('code')}`],
        Object.keys(queryParams).length ? { queryParams } : undefined
      );
      return false;
    }
    return true;
  }
}
